import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { SITE_LINKS } from '../../constants';
import { Button } from '../Button';

export interface PreClassActivity {
  id: number;
  url: string;
}

export interface CountdownWidgetContentProps {
  title?: string;
  description?: string;
  buttonText?: string;
  preActivities?: PreClassActivity[];
}

export const CountdownWidgetContent: React.FC<CountdownWidgetContentProps> = ({
  title,
  description,
  buttonText = '',
  preActivities,
}) => {
  const __ = useTranslation().t;
  const [hasOpenedActivity, setHasOpenedActivity] = useState(false);
  const hasPreActivities = !!preActivities && preActivities.length > 0;

  const onClick = () => {
    if (hasPreActivities) {
      setHasOpenedActivity(true);
    }
  };

  const btnText = hasOpenedActivity ? __('youHaveFinished') : buttonText;

  return (
    <Container>
      <TextWrapper>
        <Title>{title}</Title>
        <Description>{description}</Description>
      </TextWrapper>
      <StyledButton
        label={btnText}
        size="sm"
        href={SITE_LINKS.PreClassActivityPage}
        onClick={onClick}
        target="_blank"
      />
    </Container>
  );
};

const Container = styled.div`
  padding: 12px 16px;
  background: ${({ theme }) => theme.colors.backgroundLight};
  border-radius: 12px;
  align-items: center;
`;

const TextWrapper = styled.div`
  margin: 0 8px;
  margin-bottom: 8px;
`;

const Title = styled.h5`
  font-family: ${({ theme }) => theme.fonts.primary.regular.fontFamily};
  font-weight: 700;
  font-size: 16px;
  line-height: 18px;
  color: ${({ theme }) => theme.colors.dark};
  margin-bottom: 4px !important;
`;

const Description = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary.regular.fontFamily};
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.dark};
`;

const StyledButton = styled(Button)`
  width: 100%;
`;
